import { RevenueOpportunityDismissalReason, RevenueOpportunityDismissalScope } from 'anchor-scout-common/types';
import { leadOpportunity, matchCard } from './opportunityCard';
import { kindText } from './opportunityLabels';
const SINGLE_CARD_DISMISS_OPTIONS = [
    'already_handled',
    'not_relevant_for_client',
    'hide_kind',
    'numbers_look_off'
];
const GROUP_CARD_DISMISS_OPTIONS = [
    'not_relevant_for_service',
    'hide_kind',
    'numbers_look_off'
];
const OPPORTUNITY_REASON_BY_OPTION = {
    already_handled: RevenueOpportunityDismissalReason.AlreadyHandled,
    not_relevant_for_client: RevenueOpportunityDismissalReason.NotRelevantForClient,
    numbers_look_off: RevenueOpportunityDismissalReason.NumbersLookOff
};
export const dismissOptions = (card)=>matchCard(card, {
        single: ()=>SINGLE_CARD_DISMISS_OPTIONS,
        group: ()=>GROUP_CARD_DISMISS_OPTIONS
    });
const opportunityDismissal = (opportunity, reason)=>({
        scope: RevenueOpportunityDismissalScope.Opportunity,
        reason,
        opportunityKey: opportunity.opportunityKey
    });
export const dismissalRequests = (card, option)=>{
    const reason = OPPORTUNITY_REASON_BY_OPTION[option];
    if (option === 'hide_kind') {
        return [
            {
                scope: RevenueOpportunityDismissalScope.Kind,
                reason: RevenueOpportunityDismissalReason.KindTurnedOff,
                kind: leadOpportunity(card).kind
            }
        ];
    }
    return matchCard(card, {
        single: (param)=>{
            let { opportunity } = param;
            return reason ? [
                opportunityDismissal(opportunity, reason)
            ] : [];
        },
        group: (group)=>option === 'not_relevant_for_service' ? [
                {
                    scope: RevenueOpportunityDismissalScope.KindService,
                    reason: RevenueOpportunityDismissalReason.NotRelevantForService,
                    kind: group.kind,
                    serviceKey: group.serviceKey,
                    serviceLabel: group.subject
                }
            ] : group.opportunities.map((member)=>opportunityDismissal(member, RevenueOpportunityDismissalReason.NumbersLookOff))
    });
};
export const settleDismissals = (results)=>{
    const dismissed = results.flatMap((result)=>result.status === 'fulfilled' ? [
            result.value
        ] : []);
    return {
        undoIds: dismissed.filter((param)=>{
            let { created } = param;
            return created;
        }).map((param)=>{
            let { id } = param;
            return id;
        }),
        dismissedCount: dismissed.length,
        failedCount: results.length - dismissed.length
    };
};
export const dismissOptionLabel = (option, kind, texts)=>{
    const menu = texts.section.dismissMenu;
    switch(option){
        case 'already_handled':
            return menu.alreadyHandled();
        case 'not_relevant_for_client':
            return menu.notRelevantForClient();
        case 'not_relevant_for_service':
            return menu.notRelevantForService();
        case 'hide_kind':
            return kindText(kind, menu.hideKind);
        case 'numbers_look_off':
            return menu.numbersLookOff();
    }
};
export const dismissedToastText = (option, texts)=>option === 'hide_kind' || option === 'not_relevant_for_service' ? texts.section.toasts.groupHidden() : texts.section.toasts.suggestionRemoved();
